<template>
	<div id="PageDetails">
		<div class="container content-summary" :class="{'getblurred': isModalVisible}">
			<Title :title="'Fahrzeug Details'"></Title>

			<div class="row">
				<div class="col wrapper-rounded-content">
					<div class="bg-blue-multiply rounded-corners"></div>

					<CarDetails></CarDetails>
				</div>
			</div>


			<div class="row">
				<div class="col text-center col-cta-button">
					<router-link :to="{name: 'PageCar'}"><button type="button" class="btn btn-primary btn-wp">Zurück zur Fahrzeugwahl</button></router-link>

				</div>
			</div>


		</div>
		<modal v-show="isModalVisible" @close="closeModal" :isModalVisible="isModalVisible"	:largeModal="true" :twoButtons="true">

			<h3 slot="headline">Dein Fahrzeug ist reserviert!</h3>
			<p slot="text">Du hast bis 1 Stunde vor der Startzeit die Möglichkeit die Buchung noch einmal zu ändern oder zu stornieren.</p>
			<template slot="closeBtn">{{ $t('To overview') }}</template>
			<template slot="firstBtn">{{ $t('Start new reservation') }}</template>
			sdfsdf
		</modal>


		<div v-show="isModalVisible" @click="closeModal" class="modal-backdrop show"></div>
	</div>
</template>

<script>
export default {
	name: 'PageDetails',
	data(){
		return {
			isModalVisible: false,

		};
	},
	methods: {
		showModal() {
			this.isModalVisible = true;
			document.body.classList.add("modal-open");
		},
		closeModal() {
			this.isModalVisible = false;
			document.body.classList.remove("modal-open");
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/components/Pages/PageDetails.vue